
import { ICreateProject } from '@/entity/project/create-project';
import { projectApi } from '@api/project-api';
import { IBootstrapTableColumn } from '@/entity/shared/bootstrap';

import { Component, Vue, Watch } from 'vue-property-decorator';
import { IProject } from '@/entity/project/project';
import { IClient } from '@/entity/shared/client';
import { IAgency } from '@/entity/project/agency';
import InputElement from '@c/shared/input-element.vue';
import { MgtPerson } from '@microsoft/mgt';
import { vxm } from '@/store';
import { appTokenMgr, IEmployeeAppRoleManager } from '@t/employee-app-role';
import { authModule } from '@t/session';
import { NU } from '@t/type';
import frenchLocale from 'date-fns/locale/fr';
import { format } from 'date-fns';
import { ICancellableResult } from '@t/ajax-wrapper';
import { IStudio } from '@/entity/project/studio';
import { ref } from 'vue';
import CustomMgtPerson from '../shared/custom-mgt-person.vue';
import { IEntity } from '@/entity/shared/EntityStoreTypes';
const componentKey = ref(0);

@Component({
    components: {
        InputElement,
        CustomMgtPerson
    }
})
export default class ProjectList extends Vue {
    private filteredDataAllColumns: string = '';
    private trigram: string = '';
    private designation: string = '';
    private entity: IEntity | null = null;
    private isInternalBusiness: boolean = false;
    private IsSale: boolean = false;
    private columnPlaceholder: string = 'Nouvelle colonne';
    private fieldSelected: string = '';
    private isBusy: boolean = true;
    // private projectsPerPage: number = 5000;
    private projectsCurrentPage: number = 1;
    private mySortBy: string = '';
    private mySortDesc: boolean = false;
    private isTrigramValid: boolean = true;
    private checkingTrigram: boolean = false;
    private projects: IProject[] = [];
    private filteredProjects: IProject[] = [];
    private clients: IClient[] = [];
    private agencies: IAgency[] = [];
    private promiseExport: boolean = false;
    private isChecked: boolean = false;
    private selectedFieldToAdd: NU<IBootstrapTableColumn> = null;
    private graphManagers: { [key: string]: string } = {}
    private projectCreateModalNoCloseOnBackDrop: boolean = false;

    private onFiltered(filteredItems: IProject[]) {
        this.filteredProjects = filteredItems;
    }

    private editProject(item: IProject, _index: number, _event: Event): void {
        if (this.canAccessDetails || (vxm.user.isCP && vxm.project.dropdownProjectListOptions.filter(project => project.id === item.id).length > 0)) {
            vxm.project.resetProject();
            this.$router.push({ name: 'project-information', params: { id: item.id + '' } });
        }
    }

    get entitiesOptions () { return vxm.entity.entities }

    get canAccessDetails(): boolean {
        return vxm.user.isAdmin || vxm.user.isAssociate || vxm.user.isDaf || vxm.user.isStudioManager;
    }

    get isReadOnly(): boolean {
        return !vxm.user.isAdmin && !vxm.user.isDaf;
    }

    get appTokenMgr(): IEmployeeAppRoleManager {
        return appTokenMgr;
    }

    get fields(): Array<IBootstrapTableColumn | string> {
        return vxm.lists.listFields('projects-list-state');
    }

    get additionalFieldChoice(): Array<IBootstrapTableColumn> {
        return vxm.lists.additionnalFieldChoice('projects-list-state');
    }

    private myCompare(itemA: any, itemB: any, key: string) {
        let b0, a0;
        let a, b;
        if (key === 'trigram' || key === 'designation') {
            const a = itemA[key];
            const b = itemB[key];
            return this.strcmp(a.toUpperCase(), b.toUpperCase());
        } else if (key === 'clients' || key === 'agencies') {
            a = itemA[key];
            b = itemB[key];
            if (a.length === 0) {
                a0 = '';
            } else if (a[0].label === undefined) {
                a0 = '';
            } else a0 = a[0].label;
            if (b.length === 0) {
                b0 = '';
            } else if (b[0].label === undefined) {
                b0 = '';
            } else b0 = b[0].label;
            return this.strcmp(a0, b0);
        } else if (key === 'studioManagerId') {
            a = itemA[key];
            if (this.graphManagers[a] === '') {
                const elementA: MgtPerson = this.$refs['studioManager' + a] as MgtPerson;
                this.graphManagers[a] = elementA && elementA.id ? elementA.personDetails?.displayName ?? 'zzzzzzzzzzzz' : '';
            }
            if (this.graphManagers[a]) {
                a0 = this.graphManagers[a].toLowerCase();
            }
            b = itemB[key];
            if (this.graphManagers[b] === '') {
                const elementB: MgtPerson = this.$refs['studioManager' + b] as MgtPerson;
                this.graphManagers[b] = elementB && elementB.id ? elementB.personDetails?.displayName ?? 'zzzzzzzzzzzz' : '';
            }
            if (this.graphManagers[b]) {
                b0 = this.graphManagers[b].toLowerCase();
            }
            if (a0 === undefined) a0 = '';
            if (b0 === undefined) b0 = '';
            return this.strcmp(a0.toUpperCase(), b0.toUpperCase());
        } else if (key === 'entity') {
            a = itemA[key];
            b = itemB[key];
            a0 = a.label;
            b0 = b.label;
            return this.strcmp(a0, b0);

        }
    }

    private strcmp(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }

    get totalProjects(): number {
        if (this.filteredProjects && this.filteredProjects.length !== this.projects.length) {
            return this.filteredProjects.length;
        }
        return this.projects.length;
    }

    private colors: string[] = [
        'rgba(255, 0, 0, 0.5)',
        'rgba(0, 255, 0, 0.5)',
        'rgba(0, 0, 255, 0.5)',
        'rgba(0, 255, 255, 0.5)',
        'rgba(255, 0, 255, 0.5)'
    ];

    private async mounted(): Promise<void> {
        vxm.app.changeTitleMain('Projets');
        vxm.app.changeTitleExt('Liste des projets');
        vxm.lists.init('projects-list-state');
        vxm.user.checkIsDaf();
        vxm.user.checkIsAdmin();
        vxm.user.checkIsRH();
        vxm.user.checkIsUser();
        vxm.user.checkIsCP();
        vxm.user.checkIsAssociate();
        vxm.user.checkIsStudioManager();
        await vxm.project.fetchDropDownProjectOptions();
        const call = await projectApi.getAllBase();
        if (call != null && call.cancelled === false && !call.error && call.datas != null) {
            for (let i = 0; i < call.datas.length; ++i) {
                if (call.datas[i].studioManagerId && this.graphManagers[call.datas[i].studioManagerId!] === undefined) {
                    this.graphManagers[call.datas[i].studioManagerId!] = '';
                }
                (call.datas[i] as any).state = this.colors[i % this.colors.length];
            }
            this.projects = call.datas;
            this.filteredProjects = call?.datas;
        }

        await vxm.entity.fetchEntities();
        this.entity = vxm.entity.entities.find((iterEntity) => iterEntity.label === "FRA") || null;

        this.isBusy = false;
    }

    public filterList(): void {
        this.listOfFilters.isSale.value = this.isChecked ? "non" : "";
        const keys = Object.keys(this.listOfFilters);
        const filtersApplied = keys.filter((x) => this.listOfFilters[x].value.length > 0);
        if (filtersApplied.length > 0) {
            this.filteredProjects = this.projects.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
            this.projects.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
        }
        this.filteredProjects = this.projects;
    }

    @Watch('trigram')
    public async trigramWatcher(): Promise<void> {
        await this.checkTrigram();
    }

    @Watch('entity')
    public async entityWatcher(): Promise<void> {
        await this.checkTrigram();
    }

    public async checkTrigram(): Promise<void> {
        if (!this.trigram || this.trigram.length !== 3 || !this.entity) {
            this.isTrigramValid = true;
            return
        }

        this.checkingTrigram = true;
        const result = await projectApi.checkTrigram(this.trigram, this.entity.id);
        this.checkingTrigram = false;
        if (result.cancelled === false && result.datas != null) {
            this.isTrigramValid = result.datas;
        }
    }

    public showModal(): void {
        (this.$refs['create-project-modal'] as any).show();
    }

    async exportProjects(): Promise<void> {
        const sortKeySelected = this.mySortBy;
        const sortKeyDescSelected = this.mySortDesc;
        const listIds =
            this.filteredProjects && this.filteredProjects.length !== this.projects.length
                ? this.filteredProjects.map((x) => x.id)
                : this.filteredDataByColumn && this.filteredDataByColumn.length !== this.projects.length
                    ? this.filteredDataByColumn.map((x) => x.id)
                    : this.projects.map((x) => x.id);
        const listAdds = vxm.lists.addedAdditionalFields('projects-list-state').map(iterField => iterField.label);
        await this.generateReport(
            projectApi.exportProjectsData(
                listIds,
                listAdds as any,
                sortKeySelected as string,
                sortKeyDescSelected as any
            ),
            `Liste_des_projets_${this.formatDate(new Date())}.xlsx`
        );
    }

    private formatDate(date: Date): string {
        return format(new Date(String(date)), 'yyyy-MM-dd', { locale: frenchLocale }) ?? '';
    }

    private async generateReport(request: Promise<ICancellableResult<string>>, reportName: string): Promise<void> {
        this.promiseExport = true;
        const response = await request;
        if (response && response.datas) {
            const blob = new Blob([response.datas], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = reportName;
            link.click();
            this.promiseExport = false;
        }
        // We wait for the file to download before removing loading state
        setTimeout(() => {
            this.promiseExport = false;
        }, 1000);
    }

    @Watch('selectedFieldToAdd')
    public addColumn(column: string, _oldVal: string): void {
        vxm.lists.addColumn({ listKey: 'projects-list-state', column });
    }

    public deleteColumn(column: string): void {
        vxm.lists.removeColumn({ listKey: 'projects-list-state', column });
    }

    public async createProject(): Promise<void> {
        if (!this.entity) return console.error(`[project-list.vue][createProject] Aucune entité sélectionnée. Vous devez avoir une erreur lors de leurs récupération.`);
        const result = await projectApi.createProject({
            trigram: this.trigram,
            designation: this.designation,
            isInternalBusiness: this.isInternalBusiness,
            entityId: this.entity.id
        } as ICreateProject);
        if (result.cancelled === false && !result.error && result.datas) {
            localStorage.setItem('selected-project', String(result.datas));
            await this.$router.push({ name: 'project-information', params: { id: result.datas } });
        }
    }

    get listOfFilters() {
        return vxm.lists.filters('projects-list-state');
    }

    get filteredDataByColumn(): IProject[] {
        const keys = Object.keys(this.listOfFilters);
        const filtersApplied = keys.filter((x) => this.listOfFilters[x].value.length > 0);
        if (filtersApplied.length > 0) {
            this.filteredProjects = this.projects.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
            return this.projects.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
        }
        this.filteredProjects = this.projects.filter((p) => filtersApplied.every((f) => this.filterListByColumn(f, p)));
        return this.projects;
    }

    public filterListByColumn(key: string, x: IProject): boolean {
        if (key === 'trigram') {
            return x.trigram.toUpperCase().includes(this.listOfFilters.trigram.value.toUpperCase());
        } else if (key === 'designation') {
            return x.designation.toLowerCase().includes(this.listOfFilters.designation.value.toLowerCase());
        } else if (key === 'clients') {
            return x.clients ? x.clients.some((c) => c.label ? c.label.toUpperCase().includes(this.listOfFilters.clients.value.toUpperCase()) : false) : false;
        } else if (key === 'agencies') {
            return x.agencies ? x.agencies.some((a) => a.label ? a.label.toUpperCase().includes(this.listOfFilters.agencies.value.toUpperCase()) : false) : false;
        } else if (key === 'studioManagerId') {
            if (x.studioManagerId) {
                let name;
                const a = x.studioManagerId;
                const elementA: MgtPerson = this.$refs['studioManager' + a] as MgtPerson;
                if (elementA && elementA.id) {
                    if (elementA.personDetails?.displayName) {
                        name = elementA.personDetails?.displayName?.toLowerCase();
                    } else return false;
                } else return false;
                return name.toUpperCase().includes(this.listOfFilters.studioManagerId.value.toUpperCase());
            } else return false;
        } else if (key === 'openingDate') {
            return (x.openingDate) ? new Date(x.openingDate).toLocaleDateString('fr-FR').includes(this.listOfFilters.openingDate.value) : false;
        } else if (key === 'closingDate') {
            return (x.closingDate) ? new Date(x.closingDate).toLocaleDateString('fr-FR').includes(this.listOfFilters.closingDate.value) : false;
        } else if (key === 'isDelegate') {
            const isDelegate = 'OUI';
            const noIsDelegate = 'NON';
            return (x.isDelegate) ? isDelegate.includes(this.listOfFilters.isDelegate.value.toUpperCase()) : noIsDelegate.includes(this.listOfFilters.isDelegate.value.toUpperCase());
        } else if (key === 'isSale') {
            const IsSale = 'OUI';
            const noIsSale = 'NON';
            return (x.isSale) ? IsSale.includes(this.listOfFilters.isSale.value.toUpperCase()) : noIsSale.includes(this.listOfFilters.isSale.value.toUpperCase());
        } else if (key === 'isInternalBusiness') {
            const IsInternalBusiness = 'OUI';
            const NoIsInternalBusiness = 'NON';
            return (x.isInternalBusiness) ? IsInternalBusiness.includes(this.listOfFilters.isInternalBusiness.value.toUpperCase()) : NoIsInternalBusiness.includes(this.listOfFilters.isInternalBusiness.value.toUpperCase());
        } else if (key === 'studio') {
            return (x.studio) ? (x.studio.code) ? x.studio.code.toUpperCase().includes(this.listOfFilters.studio.value.toUpperCase()) : false : false;
        } else if (key === 'entity') {
            return (x.entity) ? (x.entity.label) ? x.entity.label.toUpperCase().includes(this.listOfFilters.entity.value.toUpperCase()) : false : false;
        }
        else {
            return false;
        }
    }

    // Comportement qui permet de selectionner une option du sélecteur en dehors de la modale.
    onEntitySelectorOpen() {
        this.projectCreateModalNoCloseOnBackDrop = true;
    }
    onEntitySelectorClose() {
        setTimeout(() => {
            this.projectCreateModalNoCloseOnBackDrop = false;
        }, 100)
    }
}
